import type { ReportData } from '@/types/report';
import type { TableBlock, TableReference, TestBlock } from '@/types/report-payload';

const normalizeReference = (reference?: Partial<TableReference>): TableReference | null => {
    if (!reference?.source_test_id) return null;

    return {
        source_test_id: reference.source_test_id,
        source_provider: 'satepsi',
    };
};

const pickSingleReferenceFromRows = (block: TableBlock): TableReference | null => {
    const row = block.rows.find((currentRow) => {
        if (!currentRow.source_test_id) return false;
        return currentRow.source_provider === undefined || currentRow.source_provider === 'satepsi';
    });

    if (!row?.source_test_id) return null;

    return {
        source_test_id: row.source_test_id,
        source_provider: 'satepsi',
    };
};

const getSingleReferenceForBlock = (block: TableBlock): TableReference[] => {
    const existing = normalizeReference(block.references?.[0]);
    if (existing) return [existing];

    const derived = pickSingleReferenceFromRows(block);
    if (derived) return [derived];

    return [];
};

const withBlockReferences = (blocks: TestBlock[] = []): TestBlock[] => {
    return blocks.map((block) => {
        if (block.block_type !== 'table') return block;

        return {
            ...block,
            references: getSingleReferenceForBlock(block),
        };
    });
};

export const withTestBlockReferences = (data: ReportData): ReportData => {
    if (!data.tests) return data;

    return {
        ...data,
        tests: {
            ...data.tests,
            blocks: withBlockReferences(data.tests.blocks || []),
        },
    };
};
